import { Box, Tooltip } from '@mui/material'
import { useRef, useEffect, useState, PropsWithChildren } from 'react'

type Props = {
  text: string
}

export const OverflowTooltip = ({
  text,
  children,
}: PropsWithChildren & Props) => {
  const ref = useRef<HTMLDivElement>(null)
  const [isOverflowed, setIsOverflow] = useState(false)

  useEffect(() => {
    if (ref.current && ref.current) {
      setIsOverflow(ref.current.scrollWidth > ref.current.clientWidth)
    }
  }, [])

  return (
    <Tooltip
      title={text}
      arrow
      placement="right"
      disableHoverListener={!isOverflowed}
    >
      <Box
        ref={ref}
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {children}
      </Box>
    </Tooltip>
  )
}
